import { initializeApp } from "firebase/app";
import { createUserWithEmailAndPassword, getMultiFactorResolver, getAuth, signInWithEmailAndPassword, RecaptchaVerifier, PhoneAuthProvider, sendEmailVerification, PhoneMultiFactorGenerator } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA88Y6bfN0cibJQokHGPAsMdC1tVdwD2Uc",
  authDomain: "trade-view-website.firebaseapp.com",
  projectId: "trade-view-website",
  storageBucket: "trade-view-website.appspot.com",
  messagingSenderId: "261583326454",
  appId: "1:261583326454:web:9f2b5e0572c2a76cf170d7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const createUser = async (auth, email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return { ok: true, user: userCredential.user }
  } catch (error) {
    console.log(error)
    return { ok: false, msg: error.code };
  }
}

export const loginWithGoogleIP = async (email, password) => {
  const auth = getAuth();
  try {
    const response = await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    if (error.code === 'auth/multi-factor-auth-required') {
      let resolver = getMultiFactorResolver(auth, error);
      const recaptchaVerifier = new RecaptchaVerifier('sign-in-button', {
        'size': 'invisible',
        'callback': function (response) {
          // reCAPTCHA solved, you can proceed with phoneAuthProvider.verifyPhoneNumber(...).
          // onSolvedRecaptcha();
        }
      }, auth);

      try {
        const phoneInfoOptions = {
          multiFactorHint: resolver.hints[0],
          session: resolver.session
        };
        let phoneAuthProvider = new PhoneAuthProvider(auth);
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
        if (verificationId) return { ok: true, verificationId: verificationId, resolver: resolver }
        else return { ok: false }
      } catch (error) {
        console.log(error);
        recaptchaVerifier.clear();
        document.getElementById("sign-in-button-outside").innerHTML = "<div id='sign-in-button'></div>";
        return { ok: false, msg: error }
      }
    } else {
      console.log(error);
      return { ok: false, msg: error }
    }
  }

}

export const verifyEmailAddress = async (email, password) => {
  const auth = getAuth();
  let user = null;

  try {
    const response = await createUser(auth, email, password);
    if (response.ok) {

      user = response.user;
      await sendEmailVerification(user);
      return { ok: true }
    } else {
      if (response.msg === 'auth/email-already-in-use') {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        user = userCredential.user;
        await sendEmailVerification(user);
        return { ok: true }
      } else return { ok: false, msg: response.msg }
    }

  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(`${errorCode} | ${errorMessage}`);
    return { ok: false, msg: errorMessage }
  }
}
